<template>
  <L1>
    <RadioTop slot="slot_title" :defaultValue="page" @input="page=$event" :options="['優惠折扣設定', '服務費設定']"/>
    <Discount v-if="page==='優惠折扣設定'"></Discount>
    <Service v-else></Service>
  </L1>

</template>

<script>
import RadioTop from '../../components/radio/r1.vue'
import L1 from '../../components/layout/L1.vue'
import Discount from './discount.vue'
import Service from './service.vue'
export default {
  components: { L1, Discount, Service, RadioTop },
  data () {
    return {
      page: '優惠折扣設定'
    }
  }
}
</script>
